<template>
    <section class="content">
        <div v-if="changeStatus" class="">
            <div class="">
                <div class="">
                    <div id="details" class="overlay waste_type_pop">
                        <div class="overlay_inner">
                            <div class="row form-modal">
                                <vue-form :state="formstate">
                                    <h4 class="text-center">Change status of {{ houseNumber }}</h4>
                                    <div class="col-sm-12" style="padding-top:15px">
                                        <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.houseStatuss)">
                                                <label> Change Status </label>
                                                <select required v-model="houseStatuss" name="houseStatuss" class="form-control">
                                                    <option value="" disabled>Select Change Status</option>
                                                    <option v-if="houseChangeDetails.collectedStatus == 'Not Collected' " value='collected' >Collected</option>
                                                    <option v-if="houseChangeDetails.collectedStatus == 'Collected' " value='notCollected' >Not Collected</option>
                                                    <!-- <option v-for="(status, index) in houseStatus" :key="index" :value="status">
                                                        {{ status }}
                                                    </option> -->
                                                </select>
                                                <field-messages name="houseStatuss" show="$touched || $submitted" class="form-control-feedback">
                                                    <div slot="required">Status is a required field</div>
                                                </field-messages>
                                            </validate>                             
    
                                    </div>
                                 <div class="col-sm-12" v-if="houseChangeDetails.collectedStatus == 'Not Collected'" >
                                    <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleTime)">
                                        <label>Updated Time</label>
                                        <datetime v-if="!this.$route.params.tripEnd" required id="scheduleTime" type="datetime" v-model="scheduleTime" :min-datetime="new Date(this.$route.params.tripStart).toISOString()" lang="en" name="scheduleTime" input-class="form-control" class="theme-wm" placeholder="Start Date and Time"></datetime>
                                        <datetime v-if="this.$route.params.tripEnd" required id="scheduleTime" type="datetime" v-model="scheduleTime" :min-datetime="new Date(this.$route.params.tripStart).toISOString()" :max-datetime="new Date(this.$route.params.tripEnd).toISOString()" lang="en" name="scheduleTime" input-class="form-control" class="theme-wm" placeholder="Start Date and Time"></datetime>
                                        <field-messages name="scheduleTime" show="$touched || $submitted" class="form-control-feedback">
                                            <div slot="required">Updated Time is a required field</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                </vue-form>
                                <div class="form-actions">
                                    <button type="submit" @click="updateChangeStatus" :disabled="!(formstate.$dirty && formstate.$valid)" v-bind:class="'mr-2 btn gradientbt'">
                                        Update
                                    </button>
                                    <button @click="onCloseCDD" v-bind:class="'mr-5  btn btn-default'">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
        <div class="box-body">
    
            <v-server-table ref="houseDetailsTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoaded">
                <template slot="beforeBody">
                    <tr v-if="loading" class="VueTables__no-results">
                        <td class="text-center" colspan="9">
                            <pulse-loader></pulse-loader>
                        </td>
                    </tr>
                </template>
                <!-- <template slot="collectedStatus" slot-scope="props">
                    <span :style="{'color':props.row.statusColor,'font-size':'15px'}" >
                                {{props.row.collectedStatus}}
                            </span>
                </template> -->
                <template slot="actions" slot-scope="props">
                        <div class="c-pointer">                       
                            <a v-on:click.stop="actions(props.row)">Change Status</a>
                        </div>
                    </template>
            </v-server-table>
        </div>
    </section>
    </template>
    
    <script>
    import {
        USER_ROLES
    } from '../../../config';
    import {
        Event
    } from 'vue-tables-2';
    import moment from 'moment';
    import {
        mapState
    } from 'vuex';
    import {
        eventBus,
        formService,
        primarytripService
    } from '../../../services';
    import dateFormatter from "../../utilities/dateFormate";
    export default {
        name: 'houseDetails',
        data() {
            return {
                formstate: {},
                houseNumber:{},
                houseChangeDetails:{},    
                show: false,
                changeStatus: false,
                houseStatuss:{},
                scheduleTime:{},
                // houseStatus: ["Collected", "Not Collected "],    
                loading: null,
                houseDetailsTable: null,
                parameters: {},
                tripStartDate: {},
                columns: ['lineTowerName', 'hnNo', 'collectedOn', 'collectedStatus','collectedByName','statusChangedByName','actions'],
                options: {
                    highlightMatches: true,
                    headings: {
                        lineTowerName: 'Tower / Line',
                        hnNo: 'H. No.',
                        collectedOn: 'Waste Collected ON',
                        collectedStatus: 'Collection Status',
                        statusChangedByName:'Status Updated By',
                        collectedByName:'Collected By',
                        actions:'Actions'
                    },
                    templates: {
                    collectedOn(row, query) {
                        if (query.collectedOn !== "--") {
                            return dateFormatter(query.collectedOn);
                        }
                            return "--";
                        },
                    },
                    perPage: 10,
                    sortable: ['lineTowerName', 'hnNo', 'collectedOn', 'collectedStatus','collectedByName','statusChangedByName'],
                    requestFunction: request => {
                        const params = {};
                        params._id = this.$route.params._id;
                        params.tripId = this.$route.params.tripId;
                        params.page = request.page;
                        params.limit = request.limit;
                        //   params.sortBy= 'createdAt'
                        //   params.sortOrder= 'des' 
    
                        if (request.orderBy) {
                            params.sortBy = request.orderBy;
                            if (request.ascending == 1) {
                                params.sortOrder = "asc";
                            } else {
                                params.sortOrder = "dsc";
                            }
                        }
                        else {
                            params.sortBy = "lineTowerName";
                            params.sortOrder = "asc";
                        }
    
    
                        if (request.query != "") {
                            params.searchString = request.query;
                        }
                        this.loading = true;
                        return primarytripService.getcdDetails(params)
                            .catch(error => {
                                console.error('trip.requestFunction-error:', error);
                                this.$snotify.error('Get Trip', 'Error!');
                            });
                    },
                    responseAdapter: response => {
                        this.loading = false;
                        let dataResp = [];
                        response.data.response.forEach((element) => {
                            let finalData = element;
                            finalData['collectedStatus'] = element.collectedStatus != false ? 'Collected' : 'Not Collected';
                            finalData["statusColor"] = element.collectedStatus == 'Collected' ? '#0f6940' : "#f0b548";
                            finalData['collectedOn'] = element.collectedOn ? element.collectedOn : '--';
                            finalData['collectedByName'] = element.collectedByName == " " || element.collectedByName == null ? '--' :  element.collectedByName ;
                            finalData['statusChangedByName'] = element.statusChangedByName == " " ||  element.statusChangedByName == null  ?  '--' : element.statusChangedByName;
                            dataResp.push(finalData);
                        });
                        return {
                            data: dataResp,
                            count: response.data.totalCount,
                        };
                    },
                    uniqueKey: '_id',
                },
            };
        },
        methods: {
            fieldClassName: formService.fieldClassName,
            onLoaded() {
                this.houseDetailsTable = this.$refs.houseDetailsTable;
            },
            actions(data){
                this.tripStartDate = this.$route.params.tripStart
                this.houseChangeDetails = data;
                this.changeStatus = true;
                this.houseNumber = data.hnNo;
                this.houseStatuss = '';  
                this.scheduleTime = '' ;        
    
            },
            onCloseCDD() {
                this.changeStatus = false;
                this.houseStatuss = '';
                this.scheduleTime = '';
            },     
            updateChangeStatus(){
             
                let houseStatu = (this.houseStatuss === 'collected') ? true : false;         
                let changeStatus = {
                    collectedOn:this.scheduleTime,
                    collectedStatus: houseStatu,
                    tripId: this.$route.params.tripId,
                     _id: this.houseChangeDetails._id
                }                        
                
                return primarytripService
                    .updateHouseStatus(changeStatus)
                    .then((response) => {
                        this.loading = false;
                        this.flash = false;
                        this.changeStatus = false
                        this.$snotify.success("House Status has been updated successfully."); 
                        this.$refs.houseDetailsTable.refresh();               
                    })
                    .catch((error) => {
                        this.loading = false;                   
                        var errorMessage = error.data.message
                        this.$snotify.error(errorMessage, "Error!");
                        this.changeStatus = false
                    });
    
    },
        },
    };
    </script>
    
    <style scoped>
    .sorting {
        position: absolute;
        left: 319px;
        z-index: 1000;
        width: 225px;
        margin-left: 250px
    }
    
    .box-body {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
    }
    
    .inline {
        background-color: rgba(255, 132, 78);
        color: white
    }
    
    .addnew {
        background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));
        color: white
    }
    </style>
    


// WEBPACK FOOTER //
// houseDetails.vue?039eddcf